/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.publicBanners

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.publicBanners.internal.PublicBannersUseCase
import features.publicBanners.internal.PublicBannersUseCase.Params
import features.publicBanners.models.BannersModel


typealias PublicBannersState = CFlow<PublicBannersUseCaseResult?>

typealias PublicBannersUseCaseResult = Result<BannersModel>

fun PublicBannersUseCaseResult.serializePublicBannersApiResult(): SerializedResult<String> {
    return this.toJsonResult<BannersModel>()
}

/**
 * Serializes [PublicBannersState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun PublicBannersState.serializePublicBannersState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<BannersModel>()
    }.asCFlow()
}

/**
 * Acquires public business banners. [Api] class
 */
class PublicBannersApi : Api() {

    val publicBannersState: PublicBannersState
        get() = _publicBannersState.asCFlow()

    companion object {
        private val _publicBannersState: MutableStateFlow<PublicBannersUseCaseResult> = MutableStateFlow(Idle())
    }

    private val publicBannersUseCase = PublicBannersUseCase()

    /**
     * Acquires public business banners.
     */
    suspend fun getPublicBanners(
        overrideHeaders: Map<String, String>? = null,

    ): Result<BannersModel> {
        /* set state to Loading as soon as function is called */
        _publicBannersState.value = Loading()
        val result = this.publicBannersUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _publicBannersState.value = result
            return@publicBannersUseCase result
        }
        return result
    }

}
